import { FormElementTemplateForClient } from '@frontend/vanilla/core';
import { ServerFieldValidationViolation } from '@frontend/vanilla/shared/forms';

export interface ClientContentData {
    formContent: { [element: string]: FormElementTemplateForClient };
    title: string;
    messages: { [key: string]: string };
}

export class ClientMenuItem {
    text: string;
    linkAddress: string;
    htmlAttributes: any;
}

export interface BingoApiResponse {
    [key: string]: any;
    common?: { messages?: ServerFieldValidationViolation[] };
}

export interface BingoApiErrorResponse {
    errorCode: string;
    vnMessages?: ServerFieldValidationViolation[];
    data?: { common?: { messages?: ServerFieldValidationViolation[] } };
}

export interface ZipProperties {
    maxLength: number;
    minLength: number;
    regex: string;
}

export interface EventEmit {
    type: string;
    subtype: string;
    value: any;
}

export class GameData {
    gameName: string;
    gameType: string;
    ballType: string;
    launchType: string;
    gameIcon: string;
    gameId: string;
    provider: string;
    players: any;
    min_players: 75;
    accessable: boolean = false;
    buy_time: any;
    features: [];
    themeid: any;
    constructor(
        gameName: string,
        provider: string,
        gameType: string,
        ballType: string,
        launchType: string,
        gameIcon: string,
        gameId: string,
        features: any,
        players: any = 0,
        min_players: any = null,
        buy_time: any = '',
        max_player_limit: any = null,
        themeid: any = null,
    ) {
        this.gameName = gameName;
        this.gameType = gameType;
        this.ballType = ballType;
        this.launchType = launchType;
        this.gameIcon = gameIcon;
        this.gameId = gameId;
        this.provider = provider;
        this.features = features;
        this.players = players;
        this.min_players = min_players;
        this.buy_time = buy_time;
        this.min_players = max_player_limit;
        this.themeid = themeid;
    }
}
